/*--------------------------------------
COLLECTIONS BREADCRUMB
 --------------------------------------*/
Breadcrumb = {
    init: function () {

        //INSERT PARENT IN COLLECTION CHILD
        if ($(".link-parent").hasClass("link-active-child")) {
            $(".breadcrumb__collection--default").hide();
            var text_1 = $('.link-active-child').text();
            var url_1 = $('.link-active-child').attr("href");
            $("<li class='breadcrumb__parent-child t14-12'><a href='" + url_1 + "'>" + text_1 + "</a></li>").insertBefore('.breadcrumb__collection');

            var text_2 = $('.megamenu__nav .link-active').text();
            $(".breadcrumb__collection").append(text_2);
        }

        //INSERT PARENT IN COLLECTION GRANDCHILD
        if ($(".link-parent").hasClass("link-active-grandchild")) {
            $(".breadcrumb__collection--default").hide();
            var text = $('.link-active-grandchild').text();
            var url = $('.link-active-grandchild').attr("href")
            $("<li class='breadcrumb__parent t14-12'><a href='" + url + "'>" + text + "</a></li>").insertBefore('.breadcrumb__collection');

            var text_2 = $('.megamenu__nav .link-active').text();
            $(".breadcrumb__collection").append(text_2);

        }

        //INSERT PARENT 2
        var text_2 = $('.link-active-parent-2').text();
        var url_2 = $('.link-active-parent-2').attr("href");
        $("<li class='breadcrumb__parent_2 t14-12'><a href='" + url_2 + "'>" + text_2 + "</a></li>").insertAfter('.breadcrumb__parent');
    }

};

/*--------------------------------------
FILTERS
 --------------------------------------*/
Filters = {
    init: function () {
        $(".btn-show-filters").click(function () {
            $(".collection-products").toggleClass("hidden-filters");
        });

        var height = $(".collection-filter__category__childs").innerHeight();
        var height_bar = 57.3 + height;
        $(".collection-filter__category").css("height", height_bar);

        $(".collection-filter__category__parent").click(function () {
            $(".collection-filter__category").toggleClass("collection-filter__category-close");
            if ($('.collection-filter__category').hasClass("collection-filter__category-close")) {
                $(".collection-filter__category").css("height", "57.3px");
            } else {
                $(".collection-filter__category").css("height", height_bar);
            }
        });


        $(".collection-filter__block").each(function () {
            var height_div = $(".filter-group-display", this).innerHeight();
            var height_div_bar = 57.3 + height_div;
            $(this).css("height", height_div_bar);
        });

        $(".filter-group-summary").click(function () {
            var parent = $(this).closest(".collection-filter__block");
            parent.toggleClass("collection-filter__block-close");
            if (parent.hasClass("collection-filter__block-close")) {
                parent.css("height", "57.3px");
            } else {
                var height_div = $(this).next().innerHeight();
                var height_div_bar = 57.3 + height_div;
                parent.css("height", height_div_bar);
            }
        });

        //WHEN CHECK --> CLICK APPLY
        $(".filter-group-display__list-item").click(function () {
            $(".collection__products").animate({ opacity: .5 }, 100);
            $(".filter-group-display__submit input[type='submit']").click();
        });






    }

};

/*--------------------------------------
FILTERS
 --------------------------------------*/
FiltersMobile = {
    init: function () {

        $("html, body").animate({ scrollTop: 0 }, "fast");


        $(".filter-btn-mobile__btn").click(function () {
            $(".collection-products").addClass("filters-mobile--open");
        })

        $(".filters-mobile-close-btn").click(function () {
            $(".collection-products").removeClass("filters-mobile--open");
        })

        /*  --  ALL OPEN  --  */
        var height = $(".collection-filter__category__childs").innerHeight();
        var height_bar = 57.3 + height;
        $(".collection-filter__category").css("height", height_bar);

        /*  --  DISABLE CLOSE  --  */
        $(".filter-group-summary").click(function () {
            var parent = $(this).closest(".collection-filter__block");
            parent.removeClass("collection-filter__block-close");
            var height_div = $(this).next().innerHeight();
            var height_div_bar = 57.3 + height_div;
            parent.css("height", height_div_bar);
        });
    }
};


/*--------------------------------------
RESIZE
 --------------------------------------*/
Resize = {
    init: function () {
        $(document).on("scroll", function () {
            if
                ($(document).scrollTop() > 50) {
                $(".collection-header").addClass("header-resize");
            }
            else {
                $(".collection-header").removeClass("header-resize");
            }
        });

    }

};


/*--------------------------------------
COLLECTIONS BANNERS
 --------------------------------------*/
CollectionBanners = {
    init: function () {
        //INSERT BANNER IN GRID
        $(".banner-item").each(function () {
            var position = $(this).data('position') - 1;
            $(this).appendTo(".collection__products");
            //$(this).insertBefore(".pagination");
            $(this).insertAfter(".collection__products .product-card:nth-child(" + position + ")");
        });

    }

};

/*----------------------
 WHEN SCROLL UP
 ----------------------*/
ScrollUp = {
    init: function () {
        var mywindow = $(window);
        var mypos = mywindow.scrollTop();
        mywindow.scroll(function () {
            if (mywindow.scrollTop() > mypos) {
                $('.collection-header.header-resize').addClass("hidden");
                $(".collection-filters").addClass("top");
            }
            else {
                $('.collection-header.header-resize').removeClass("hidden");
                $(".collection-filters").removeClass("top");
            }
            mypos = mywindow.scrollTop();
        });
    }
};


$(function () {
    Breadcrumb.init();
    Filters.init();
    Resize.init();
    CollectionBanners.init();
    ScrollUp.init();

    if ($(window).width() <= 768) {
        FiltersMobile.init();
    }

    $("body.collection").animate({ opacity: 1 }, 400);
});


//INFINIT SCROLL & LAZYLOAD
$('.collection__products').infiniteScroll({
    // options
    path: '.collection__products .next a',
    append: '.product-card',
    history: false,
    hideNav: '.product-pagination',
    status: '.page-load-status',
});